import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Card from 'src/components/common/Card.redesign';
import BillingAndPaymentCycle from 'src/models/BillingAndPaymentCycle';
import Landman from 'src/models/Landman';
import ProjectAdministratorStaff from 'src/models/ProjectAdministratorStaff';
import ProjectStaff from 'src/models/ProjectStaff';
import User from 'src/models/User';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import ProjectWorkClassification from 'src/models/ProjectWorkClassification';
import moment from 'moment';

interface IStaffingLandmanCard {
    projectStaffInfo: ProjectStaff;
    landman: Landman;
    index: number;
    userList: User[];
    projectAdminStaff: ProjectAdministratorStaff[];
    submitListener: boolean;
    billingCycles: BillingAndPaymentCycle[];
    workClassifications: ProjectWorkClassification[];
    submitStaffingForm: (data: ProjectStaff) => void;
    showDialog?: ContextMenuAction[];
    hideDialog?: () => void;
    defaultBillRate?: number;
    defaultPayRate?: number;
    defaultPM?: number;
    defaultPCAPM?: number;
}

const currentMonth = moment(new Date()).month() + 1;

const StaffingLandmanCard = (props: IStaffingLandmanCard) => {
    const { getValues, register, errors } = useForm();

    useEffect(() => {
        if (props.submitListener === true) {
            submitForm();
        }
    }, [props.submitListener]);

    const currentBillCycle = () => {
        let cycle = props.billingCycles.find((bc) => moment(bc.startDate).month() + 1 === currentMonth);
        return cycle;
    };

    const submitForm = () => {
        let ref = getValues();

        let defaultCycle = currentBillCycle();

        const submitInfo: ProjectStaff = {
            id: props.projectStaffInfo ? props.projectStaffInfo.id : 0,
            userId: props?.landman ? props?.landman.id : null,
            startDate: ref?.startDate || null,
            endDate: ref?.endDate || null,
            projectAdministratorId: ref.projectAdministratorId || null,
            projectManagerId: ref.projectManagerId,
            pcapmId: ref.pcapmId ? ref.pcapmId : null,
            isOverride: ref?.isOverride || null,
            startBillingCycleId: parseInt(ref.startBillingCycleId + '', 10),
            endBillingCycleId: parseInt(ref.endBillingCycleId + '', 10),
            overrideBillRate: ref.overrideBillRate === '' ? 0 : ref.overrideBillRate,
            overridePayRate: ref.overridePayRate === '' ? 0 : ref.overridePayRate,
            ownershipAccess: ref.ownershipAccess,
            contractAccess: ref.contractAccess,
            reportAccess: ref.reportAccess,
            workClassificationId: ref.workClassificationId ? ref.workClassificationId : null,
        };

        console.log('before if checks', submitInfo);

        if (submitInfo.startBillingCycleId === submitInfo.endBillingCycleId) {
            submitInfo.startBillingCycleId = defaultCycle.id;
            submitInfo.endBillingCycleId = parseInt(defaultCycle.id + '', 10) + 2;
        }

        console.log('after if checks', submitInfo);

        props.submitStaffingForm(submitInfo);
    };

    return (
        <>
            <Card badge={props.projectStaffInfo?.pendingCycle ? 'Pending new cycle' : ''} newContext={false}>
                <div className="mb-1 mt-1" key={`Staff${props.index}`}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 3rem 0 3rem', gap: '3%' }}>
                        <div style={{ width: '120px' }}>
                            <p>{`${props.landman.firstName} ${props.landman.lastName}`}</p>
                        </div>
                        <div style={{ width: '160px' }}>
                            <RHFSelect
                                bodyStyle={{ display: 'flex', marginBottom: '1rem' }}
                                style={{ width: '100%' }}
                                label=""
                                name="startBillingCycleId"
                                options={
                                    props?.billingCycles
                                        ? props?.billingCycles?.map((c: BillingAndPaymentCycle) => {
                                              let year = new Date(c?.endDate).getFullYear();
                                              if (c.cycleNumber <= 9) {
                                                  return {
                                                      value: c.id,
                                                      label: `${year} - 0${c.cycleNumber}`,
                                                  };
                                              }

                                              return {
                                                  value: c.id,
                                                  label: `${year} - ${c.cycleNumber}`,
                                              };
                                          })
                                        : []
                                }
                                register={register}
                                errors={errors}
                            />
                        </div>
                        <div style={{ width: '160px' }}>
                            <RHFSelect
                                bodyStyle={{ display: 'flex', marginBottom: '1rem' }}
                                style={{ width: '100%' }}
                                label=""
                                name="endBillingCycleId"
                                options={
                                    props?.billingCycles
                                        ? props?.billingCycles?.map((c: BillingAndPaymentCycle) => {
                                              let year = new Date(c?.endDate).getFullYear();
                                              if (c.cycleNumber <= 9) {
                                                  return {
                                                      value: c.id,
                                                      label: `${year} - 0${c.cycleNumber}`,
                                                  };
                                              }

                                              return {
                                                  value: c.id,
                                                  label: `${year} - ${c.cycleNumber}`,
                                              };
                                          })
                                        : []
                                }
                                register={register}
                                errors={errors}
                            />
                        </div>
                        <div style={{ width: '120px' }}>
                            <RHFInputBox
                                bodyStyle={{ display: 'flex', marginBottom: '1rem' }}
                                style={{ width: '100%' }}
                                name="overridePayRate"
                                label=""
                                type="text"
                                register={register}
                                errors={errors}
                                defaultVal={props.defaultPayRate ? `${props.defaultPayRate}` : ''}
                            />
                        </div>
                        <div style={{ width: '120px' }}>
                            <RHFInputBox
                                bodyStyle={{ display: 'flex', marginBottom: '1rem' }}
                                style={{ width: '100%' }}
                                name="overrideBillRate"
                                label=""
                                type="text"
                                register={register}
                                errors={errors}
                                defaultVal={props.defaultBillRate ? `${props.defaultBillRate}` : ''}
                            />
                        </div>
                        <div style={{ width: '150px' }}>
                            <RHFSelect
                                bodyStyle={{ display: 'flex', marginBottom: '1rem' }}
                                style={{ width: '100%' }}
                                name="pcapmId"
                                label=""
                                options={
                                    props?.userList
                                        ? props.userList
                                              .filter((u) => u?.role?.id === 3)
                                              .map((u) => {
                                                  return { value: u.id, label: `${u.firstName} ${u.lastName}` };
                                              })
                                        : []
                                }
                                register={register}
                                errors={errors}
                                defaultVal={props.defaultPCAPM}
                            />
                        </div>
                        <div style={{ width: '150px' }}>
                            <RHFSelect
                                bodyStyle={{ display: 'flex', marginBottom: '1rem' }}
                                style={{ width: '100%' }}
                                name="workClassificationId"
                                label=""
                                defaultVal={8}
                                options={
                                    props?.workClassifications
                                        ? props.workClassifications.map((wc) => {
                                              return { value: wc.id, label: `${wc.alias} - ${wc.name}` };
                                          })
                                        : []
                                }
                                register={register}
                                errors={errors}
                            />
                        </div>
                        <div style={{ width: '140px' }}>
                            <RHFSelect
                                bodyStyle={{ display: 'flex', marginBottom: '1rem' }}
                                style={{ width: '100%' }}
                                name="projectManagerId"
                                label=""
                                defaultVal={props.defaultPM}
                                options={
                                    props?.userList
                                        ? props.userList
                                              .filter((u) => u?.role?.id === 2)
                                              .map((u) => {
                                                  return { value: u.id, label: `${u.firstName} ${u.lastName}` };
                                              })
                                        : []
                                }
                                register={register}
                                errors={errors}
                            />
                        </div>
                        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', width: '300px' }}>
                            <input type="checkbox" name="ownershipAccess" ref={register} defaultChecked={true} />
                            <label htmlFor="permission1">Ownership Access?</label>
                            <input type="checkbox" name="contractAccess" ref={register} />
                            <label htmlFor="permission2">Contract Access?</label>
                            <input type="checkbox" name="reportAccess" ref={register} />
                            <label htmlFor="permission3">Report Access?</label>
                        </div>
                    </div>
                </div>
            </Card>
        </>
    );
};

export default StaffingLandmanCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/StaffingLandmanCard.tsx